export default "__VITE_ASSET__BnePPvPu__"